<template>
  <div class="box">

    <!-- 头部 -->
    <customNavBar>
      <template #title>
        <van-tabs v-model="active" class="tabs" @change="onChange">
          <van-tab name="food" title="餐饮推荐" />
          <van-tab name="live" title="住宿推荐" />
        </van-tabs>
      </template>
    </customNavBar>

    <!-- 内容 -->
    <bigCard :key="active" :data="active === 'food' ? foodList: liveList" />

    <!-- 背景 -->
    <img class="bg-img1" :src="require('@/assets/bg01.png')">
  </div>
</template>

<script>
import customNavBar from "@/components/CustomNavBar";
import bigCard from "@/components/CustomCard/bigCard.vue";

import { mapGetters } from "vuex";
export default {
  name: "LIST",
  components: {
    customNavBar,
    bigCard
  },
  data() {
    return {
      active: ''
    };
  },
  computed: {
    ...mapGetters(["foodList", "liveList", "foodActive"]),
  },
  mounted() {
    this.active = this.foodActive
    this.$store.commit('set_istab', true)
  },
  methods: {
    onChange(index) {
      this.$store.commit('set_food_active', index)
    }
  }
};
</script>

<style lang="scss" scoped>
.box {
  height: 100%;
  background: #f5f7fa;
}
</style>
